// extracted by mini-css-extract-plugin
module.exports = {"HeroHeading":"AppError_HeroHeading__33dxu","ResetButton":"AppError_ResetButton___3ZpV","Error":"AppError_Error__3zAqS","ErrorTitle":"AppError_ErrorTitle__yKKuU"};